export default __webpack_public_path__ + "static/media/OmaduroDoubleToroOpen.c6168a0a.jpg";